import * as actionTypes from './actionTypes'

import perspectiveAxios from '../../axios/perspective'
import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'

export const fetchPerspective = filterOptions => {
  return dispatch => {
    const params = {
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10,
      company_id: filterOptions ? filterOptions.company_id : null,
      perspective_id: filterOptions ? filterOptions.perspective_id : null,
      is_active: filterOptions ? filterOptions.is_active : null
    }
    dispatch(fetchPerspectiveStart())
    perspectiveAxios
      .get(filterOptions ? filterOptions.recordId : '', {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: +per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchPerspectiveSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchPerspectiveFailed(error))
      })
  }
}

export const fetchPerspectiveStart = () => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_START
  }
}

export const fetchPerspectiveSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_SUCCESS,
    pagination,
    records
  }
}

export const fetchPerspectiveFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FAILED,
    errorMessage
  }
}

export const fetchPerspectiveById = recordId => {
  return dispatch => {
    dispatch(fetchPerspectiveStart())
    perspectiveAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPerspectiveByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPerspectiveFailed(error))
      })
  }
}

export const fetchPerspectiveByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedPerspectiveRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_PERSPECTIVE_RECORD
  }
}

export const createPerspective = (recordData, page) => {
  return dispatch => {
    dispatch(createPerspectiveStart())

    perspectiveAxios
      .post('', recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Perspective Created',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(createPerspectiveSuccess())
        dispatch(fetchPerspective(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Organization field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createPerspectiveFailed())
      })
  }
}

export const createPerspectiveStart = () => {
  return {
    type: actionTypes.CREATE_PERSPECTIVE_START
  }
}

export const createPerspectiveSuccess = () => {
  return {
    type: actionTypes.CREATE_PERSPECTIVE_SUCCESS
  }
}

export const createPerspectiveFailed = () => {
  return {
    type: actionTypes.CREATE_PERSPECTIVE_FAILED
  }
}

export const updatePerspective = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updatePerspectiveStart())
    perspectiveAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Perspective Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updatePerspectiveSuccess())
        dispatch(fetchPerspective(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Invalid perspective field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
          })
        )
        dispatch(updatePerspectiveFailed())
      })
  }
}

export const updatePerspectiveStart = () => {
  return {
    type: actionTypes.UPDATE_PERSPECTIVE_START
  }
}

export const updatePerspectiveSuccess = () => {
  return {
    type: actionTypes.UPDATE_PERSPECTIVE_SUCCESS
  }
}

export const updatePerspectiveFailed = () => {
  return {
    type: actionTypes.UPDATE_PERSPECTIVE_FAILED
  }
}

export const deletePerspective = (recordId, page) => {
  return dispatch => {
    dispatch(deletePerspectiveStart())
    perspectiveAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Perspective Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deletePerspectiveSuccess())
        dispatch(fetchPerspective(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deletePerspectiveFailed())
      })
  }
}

export const fetchPerspectiveFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchPerspectiveFilterCompanyStart())
    perspectiveAxios
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPerspectiveFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPerspectiveFilterCompanyFailed(error))
      })
  }
}

export const fetchPerspectiveFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_COMPANY_START
  }
}

export const fetchPerspectiveFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchPerspectiveFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchPerspectiveFiler = filter => {
  return dispatch => {
    dispatch(fetchPerspectiveFilerStart())
    perspectiveAxios
      .get('/dropdown',{ params: filter })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchPerspectiveFilerSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPerspectiveFilerFailed(error))
      })
  }
}

export const fetchPerspectiveFilerStart = () => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_START
  }
}

export const fetchPerspectiveFilerSuccess = data => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_SUCCESS,
    data
  }
}

export const fetchPerspectiveFilerFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_FAILED,
    errorMessage
  }
}

export const deletePerspectiveStart = () => {
  return {
    type: actionTypes.DELETE_PERSPECTIVE_START
  }
}

export const deletePerspectiveSuccess = message => {
  return {
    type: actionTypes.DELETE_PERSPECTIVE_SUCCESS,
    message
  }
}

export const deletePerspectiveFailed = errorMessage => {
  return {
    type: actionTypes.DELETE_PERSPECTIVE_FAILED,
    errorMessage
  }
}

export const fetchPerspectiveFilterActive = () => {
  return dispatch => {
    dispatch(fetchPerspectiveFilterActiveStart())
    let active = [
      {
        active_id: 1,
        active_code: 1,
        active_name: 'Active'
      },
      {
        active_id: 0,
        active_code: 0,
        active_name: 'Inactive'
      }
    ]

    if (active) {
      dispatch(fetchPerspectiveFilterActiveSuccess(active))
    } else {
      dispatch(fetchPerspectiveFilterActiveFailed('Get active fail'))
    }
  }
}

export const fetchPerspectiveFilterActiveStart = () => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_ACTIVE_START
  }
}

export const fetchPerspectiveFilterActiveSuccess = data => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_ACTIVE_SUCCESS,
    data
  }
}

export const fetchPerspectiveFilterActiveFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_FILTER_ACTIVE_FAILED,
    errorMessage
  }
}
